import theme from "@/styles/theme";
import styled from "styled-components";

export const LabelItem = styled.span`
  font-family: sans-serif;
  font-weight: 700;
`;

interface ISideBarMenuProps {
  collapsed?: boolean;
}

/**
 * No desktop:
 *  - Quando colapsado: 5rem (apenas ícones visíveis)
 *  - Quando aberto: 16rem (ícones + texto)
 *
 * No mobile:
 *  - Quando colapsado: largura 0 (menu totalmente escondido)
 *  - Quando aberto: 16rem
 */
export const SideBarMenu = styled.div<ISideBarMenuProps>`
  display: flex;
  flex-direction: column;
  background-color: #42372b;
  z-index: 50;
  transition: width 0.3s ease;
  overflow: hidden; /* Esconde o conteúdo quando a largura é 0 */
  width: ${({ collapsed }) => (collapsed ? "5rem" : "16rem")};

  @media (${theme.devices.tablet}) {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: ${({ collapsed }) => (collapsed ? "0" : "16rem")};
  }
`;

/**
 * Botão de toggle fixo para mobile.
 * É exibido apenas em telas pequenas.
 */
export const ToggleButtonWrapper = styled.div`
  position: fixed;
  top: 90px;
  left: 10px;
  z-index: 40;
  background-color: #231f20;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 40;
  overflow: hidden;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const FlexContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 300ms ease;
`;
